function getLoadingIcon(type) {
	let loadingIcon;

	switch (type) {
		case 'spinnerlarge':
			loadingIcon = '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>';
			break;
		case 'spinnersmall':
			loadingIcon = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
			break;
		default:
			loadingIcon = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
			break;
	}

	return loadingIcon;
}

const btnloading = {
	mounted(el, binding) {
		// If data-text is not specified on the button, add it and set it to the current innerHTML of the element
		if (!('text' in el.dataset)) {
			el.dataset.text = el.innerHTML;
		}
		
		// If data-width is not specified on the button, add it and (try to) set it to the current offsetWidth of the element
		if (!('width' in el.dataset)) {
			el.dataset.width = el.offsetWidth; // el.offsetWidth seems to return 0 every time here? Maybe we should just set it to 0 instead?
		}
	},

	beforeUpdate(el) {
		if (el.dataset.width == '0') {
			el.dataset.width = el.offsetWidth; // This seems to return the proper width of the element here
		}
	},
	
	updated(el, binding) {
		if (binding.value !== binding.oldValue) {
			if (binding.value === true) {
				// Currently loading/saving, apply width & disabled status to element and replace btn text with icon
				el.style.width = el.dataset.width + 'px';
                el.classList.add('disabled');
                el.setAttribute('disabled', 'disabled');
				el.innerHTML = getLoadingIcon(binding.arg);
			} else {
				// Not currently loading/saving, remove width & disabled status from element and set btn to original text
				el.style.removeProperty('width');
                el.classList.remove('disabled');
                el.removeAttribute('disabled');
				el.innerHTML = el.dataset.text;
			}
		}
	}
}

export default btnloading;
